const selects = [
  { className: 'updateBranch', value: 2 },
  { className: 'updateBranchForExistingPackets', value: 3 },
];

$(function() {
  $.nette.ext({
    complete: function() {
      $('#frm-zipCodesControl-filterFormControl-list-filter-group_action-group_action').on('change', function() {
        const selectedValue = $(this).find(':selected').val();
        hideGroupActionSelects(selects, selectedValue);
      });
    }
  })

  $('#frm-zipCodesControl-filterFormControl-list-filter-group_action-group_action').on('change', function() {
    const selectedValue = $(this).find(':selected').val();
    hideGroupActionSelects(selects, selectedValue);
  });
});

function hideGroupActionSelects(selects, selectedValue)
{
  selects.forEach(function(select) {
    const element = $('.' + select.className);

    if (select.value == selectedValue) {
      element.next('.select2-container').show();
    } else {
      element.next('.select2-container').hide();
    }
  });
}

$(window).on('load', function() {
  selects.forEach(function(select) {
    const element = $('.' + select.className);

    if (element.is(':hidden')) {
      element.next('.select2-container').hide();
    } else {
      element.next('.select2-container').show();
    }
  });
});
